import { getWorkflow as getWorkflowCommon } from '@jira/project-settings__workflow-services-document/src/getApiPrefix.tsx';
import type { MetaWorkflowDocumentWithUsages } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import { transformAPIToMetaDocument } from './transformAPIToMetaDocument.tsx';

type WorkflowIdentifier = {
	workflowId?: string;
	workflowName?: string;
	projectAndIssueType?: {
		projectId: string;
		issueTypeId: string;
	};
};

export type GetWorkflowConfigOptions = { checkForDrafts?: boolean; getDrafts?: boolean };

const getWorkflow = async (
	cloudId: string,
	workflowIdentifier: WorkflowIdentifier,
	config?: GetWorkflowConfigOptions,
): Promise<MetaWorkflowDocumentWithUsages> => {
	const result = await getWorkflowCommon(cloudId, workflowIdentifier, config);
	return transformAPIToMetaDocument(result);
};

export default getWorkflow;
